var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.bannerPic ? 'bg_image' : 'bg_image_web'],style:(_vm.bgStyle)},[(!_vm.isSlotsRedirect)?_c('img',{attrs:{"src":'../../static/images/' + _vm.logoImage}}):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49dec376","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 505
// module chunks = 1